"use client";
export * from "./FullScreenDialog";
export { default } from "./FullScreenDialog";
